var _console;

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each"; // @warn Don't modify this carefully cleaned up integration snippet unless absolutely necessary!
// Create a queue, but don't obliterate an existing one!

var analytics = window.analytics = window.analytics || []; // If the real analytics.js is already on the page, no action needed.

if (!analytics.initialize) if (analytics.invoked) // If the snippet was invoked already, show an error.
  (_console = console) === null || _console === void 0 ? void 0 : _console.error('Segment snippet included twice.');else {
  var _context2; // Invoked flag, to make sure the snippet is never invoked twice.


  analytics.invoked = true; // A list of the methods in Analytics.js to stub.

  analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware']; // Define a factory to create stubs. These are placeholders for methods in Analytics.js so that you never have to wait
  // for it to load to actually record data. The `method` is stored as the first argument, so we can replay the data.

  analytics.factory = function (method) {
    return function () {
      var _context;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      analytics.push(_concatInstanceProperty(_context = [method]).call(_context, args));
      return analytics;
    };
  }; // For each of our methods, generate a queueing stub.


  _forEachInstanceProperty(_context2 = analytics.methods).call(_context2, function (method) {
    analytics[method] = analytics.factory(method);
  }); // Define a method to load Analytics.js from our CDN, and that will be sure to only ever load it once.


  analytics.load = function (appId, options) {
    // Create an async script element based on your key.
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = "https://cdn.segment.com/analytics.js/v1/".concat(appId, "/analytics.min.js"); // Insert our script next to the first script element.

    var first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(script, first);
    analytics._loadOptions = options;
  }; // Add a version to keep track of what's in the wild.


  analytics.SNIPPET_VERSION = '4.1.0';
}